import { Center, Text } from "@chakra-ui/react";
import React from "react";
export const DefaultErrorView = ({ error }) => /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement(Text, { p: "40px", color: "uiRed", textStyle: "body-3" }, error));
